import React from 'react';
import { useLocation } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import queryString from 'query-string';
import { Spinner, ErrorMessage } from '@gsa/afp-component-library';
import Truncate from '../../../../components/Truncate';
import Comment from '../../components/comment';
import { useFvsRequirements } from '../requirements-provider';

const useGetComment = (commentId, isCommentLoaded) => {
  const queryResult = useQuery(
    gql`
      query getCommentById($id: Float!) {
        getCommentById(id: $id) {
          id
          comment
          repliesCount
          status
          authorType
          createdByUser
          createdByUserInfo {
            id
            fullName
            email
          }
          createdAt
          publishStatus
          replies {
            id
            comment
            status
            authorType
            createdByUser
            createdAt
            publishStatus
            createdByUserInfo {
              id
              fullName
              email
            }
          }
          linkedEntity {
            ... on EquipmentAssociation {
              standardItemId
              equipmentCodeId
              associationTypeCode
              associationText
              standardItem {
                standardItemNumber
              }
              associationType {
                title
              }
              equipmentCode {
                code
                title
                program
                category
                content {
                  content
                }
              }
            }
          }
        }
      }
    `,
    {
      variables: {
        id: parseInt(commentId, 10),
      },
      skip: !commentId || isCommentLoaded,
    },
  );

  return queryResult;
};

const CommentDetail = () => {
  const location = useLocation();
  const { commentId: urlCommentId } = queryString.parse(location?.search);
  const { selectedComment, equipmentAssociation } = useFvsRequirements();
  const isCommentLoaded = !!(selectedComment?.id);
  const commentId = selectedComment?.id || urlCommentId;
  const commentQueryResult = useGetComment(commentId, isCommentLoaded);
  const comment = selectedComment || commentQueryResult.data?.getCommentById;
  const eqAssociation = equipmentAssociation || comment?.linkedEntity;

  // Only show spinner when actually fetching (not when comment already loaded from table click)
  if (!isCommentLoaded && (!commentQueryResult.called || commentQueryResult.loading)) {
    return <Spinner />;
  }
  if (commentQueryResult.error) {
    return <ErrorMessage>{commentQueryResult.error.message}</ErrorMessage>;
  }

  if (!comment) {
    return <ErrorMessage>Comment not found</ErrorMessage>;
  }

  return (
    <>
      <div className="grid-col">
        <Comment comment={comment} />
        <br />
        <div
          style={{ borderLeft: '1px solid #DFE1E2' }}
          className="padding-left-2"
        >
          {comment?.replies?.map((reply, i) => (
            <div
              key={reply.id}
              className={`${i === 0 ? 'margin-top-2' : 'margin-top-4'}`}
            >
              <ul className="add-list-reset">
                <li className="margin-bottom-4">
                  <Comment comment={reply} />
                </li>
              </ul>
            </div>
          ))}
        </div>
        <hr />
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className="text-bold" tabIndex="0">
          Equipment Code
        </div>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <span tabIndex="0">{eqAssociation?.equipmentCode?.code}</span>
        <br />
        <br />
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className="text-bold" tabIndex="0">
          Long title
        </div>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <span tabIndex="0">{eqAssociation?.equipmentCode?.title}</span>
        <br />
        <br />
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className="text-bold" tabIndex="0">
          Description
        </div>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <span tabIndex="0">
          {eqAssociation?.equipmentCode?.content?.content && (
            <Truncate
              size={500}
              content={eqAssociation?.equipmentCode?.content?.content}
            />
          )}
          {!eqAssociation?.equipmentCode?.content?.content && (
            <span>&ndash;</span>
          )}
        </span>
        <br />
        <br />
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className="text-bold" tabIndex="0">
          Category
        </div>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <span tabIndex="0">{eqAssociation?.equipmentCode?.category}</span>
        <br />
        <br />
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className="text-bold" tabIndex="0">
          Standard/Optional
        </div>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <span tabIndex="0">{eqAssociation?.associationType?.title}</span>
      </div>
    </>
  );
};

CommentDetail.propTypes = {};

export default CommentDetail;
